import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteTextAutomation as DeleteTextAutomationMutation,
    DeleteTextAutomationVariables as DeleteTextAutomationMutationVariables,
    TextAutomationDeleteInput,
} from 'nutshell-graphql-types';

import {refetchSalesAutomationOpenLeadQueries} from '../../app/sales-automation-open-leads';

import DELETE_TEXT_AUTOMATION from '../mutations/delete-text-automation.graphql';

export const useDeleteTextAutomation = (): {
    deleteTextAutomation: (input: TextAutomationDeleteInput, stageId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteTextAutomation, {loading, error}] = useMutation<
        DeleteTextAutomationMutation,
        DeleteTextAutomationMutationVariables
    >(DELETE_TEXT_AUTOMATION);

    return {
        deleteTextAutomation: (input: TextAutomationDeleteInput, stageId: string) => {
            return deleteTextAutomation({
                variables: {
                    textAutomation: input,
                },
                // @ts-expect-error
                refetchQueries: refetchSalesAutomationOpenLeadQueries({stageId: stageId}),
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
